export const ConnectorIcon = () => {
  return (
    <svg
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.4165 12.5833L2.4165 17.4167C2.4165 18.084 2.95749 18.625 3.62484 18.625L8.45817 18.625C9.12551 18.625 9.6665 18.084 9.6665 17.4167L9.6665 12.5833C9.6665 11.916 9.12551 11.375 8.45817 11.375L3.62484 11.375C2.95749 11.375 2.4165 11.916 2.4165 12.5833Z"
        fill="#47BE79"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7502 24.6667L16.9168 24.6667C16.2495 24.6667 15.7085 24.1257 15.7085 23.4583L15.7085 6.54167C15.7085 5.87431 16.2495 5.33334 16.9168 5.33334L21.7502 5.33334"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5833 24.6667C26.5833 23.332 25.5014 22.25 24.1667 22.25C22.832 22.25 21.75 23.332 21.75 24.6667C21.75 26.0013 22.832 27.0833 24.1667 27.0833C25.5014 27.0833 26.5833 26.0013 26.5833 24.6667Z"
        fill="#47BE79"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5833 5.33333C26.5833 3.99865 25.5014 2.91667 24.1667 2.91667C22.832 2.91667 21.75 3.99865 21.75 5.33333C21.75 6.66802 22.832 7.75 24.1667 7.75C25.5014 7.75 26.5833 6.66802 26.5833 5.33333Z"
        fill="#47BE79"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5833 15C26.5833 13.6653 25.5014 12.5833 24.1667 12.5833C22.832 12.5833 21.75 13.6653 21.75 15C21.75 16.3347 22.832 17.4167 24.1667 17.4167C25.5014 17.4167 26.5833 16.3347 26.5833 15Z"
        fill="#47BE79"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6665 15L21.7498 15"
        stroke="#19AE57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
